import { useLocation } from 'react-router-dom-v5-compat';

/** Reasons the sign-in screen can show an alert on arrival. */
export type LoginAlert =
  | 'emailDuplicateKey'
  | 'invitationAlreadyRedeemed'
  | 'passwordResetFailed';

/** State that login screens pass to each other through the router. */
export interface LoginLocationState {
  alert?: LoginAlert;
  formHints?: { email?: string };
  passwordResetSent?: boolean;
}

/** The parts of a location that login reads. State is absent on direct visits. */
export interface LoginLocation {
  search: string;
  state?: LoginLocationState | null;
}

/** The v6 location with its router state typed. */
export function useLoginLocation(): LoginLocation & { pathname: string } {
  return useLocation();
}
